<ng-container *ngFor="let type of composition | keyvalue; let isLast=last;">
    {{ type.value }} {{ 'listings.typologies.bedTypes.' + (type.key | uppercase) + ((type.value > 1) ? '_PLURAL' : '') | translate | lowercase }}{{isLast ? '' : ', '}}
</ng-container>